import { Link, useLocation } from "react-router-dom";
import { languages } from "../i18n.js";
import SearchBar from "./SearchBar.jsx";

const PAGES = ["home", "blog", "experience", "study", "certificates", "projects", "contact"];

export default function Header({ themeMode, setThemeMode, language, setLanguage, t, copy }) {
  const location = useLocation();

  return (
    <header style={{
      marginBottom: 56,
      borderBottom: `1px solid ${t.border}`,
      paddingBottom: 20,
    }}>
      <div style={{
        fontFamily: "'JetBrains Mono', monospace",
        fontWeight: 500,
        fontSize: 15,
        marginBottom: 24,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <Link to="/" style={logoButtonStyle(t)}>
          Hamza Ouabiba
        </Link>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>
          <select
            aria-label={copy.language}
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            style={selectStyle(t)}
          >
            {Object.entries(languages).map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>

          <select
            aria-label={copy.theme}
            value={themeMode}
            onChange={(e) => setThemeMode(e.target.value)}
            style={selectStyle(t)}
          >
            <option value="system">{copy.system}</option>
            <option value="light">{copy.light}</option>
            <option value="dark">{copy.dark}</option>
          </select>
        </div>
      </div>

      <nav style={{ display: "flex", gap: 24, flexWrap: "wrap", alignItems: "center" }}>
        {PAGES.map((page) => {
          const path = page === "home" ? "/" : `/${page}`;
          const isActive = location.pathname === path;

          return (
            <Link key={page} to={path} style={navButtonStyle(t, isActive)}>
              {copy.nav[page]}
            </Link>
          );
        })}
      </nav>

      <SearchBar t={t} copy={copy} language={language} />
    </header>
  );
}

function logoButtonStyle(t) {
  return {
    color: t.text,
    fontFamily: "'JetBrains Mono', monospace",
    fontWeight: 500,
    fontSize: 15,
    textDecoration: "none",
  };
}

function navButtonStyle(t, isActive) {
  return {
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 13,
    color: isActive ? t.text : t.dim,
    fontWeight: isActive ? 500 : 400,
    textDecoration: "none",
  };
}

function selectStyle(t) {
  return {
    background: t.bg,
    color: t.text,
    border: `1px solid ${t.border}`,
    borderRadius: 8,
    padding: "6px",
    outline: "none",
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 12,
    cursor: "pointer",
  };
}
